// extracted by mini-css-extract-plugin
export var actionButton = "_ed-0";
export var fileInput = "_ed-2";
export var paperclip = "_ed-1";